import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.threshold = 400
    this.update = this.update.bind(this)
    window.addEventListener("scroll", this.update, { passive: true })
    this.update()
  }

  disconnect() {
    window.removeEventListener("scroll", this.update)
  }

  update() {
    this.element.classList.toggle("is-visible", window.scrollY > this.threshold)
  }
}
